import React, {Fragment} from "react";
import {HitlistEntry, NumberWithUnit} from "../models/models";
import {
    Skeleton,
    View,
    Avatar,
    Text,
} from "reshaped";
import {QualityBadge, AccessibilityIndicator} from "./badges";
import {useTranslation} from "react-i18next";


interface EntryTileProps {
    entry: HitlistEntry;
    distance: NumberWithUnit | null;
}

export function EntryTile({entry, distance}: EntryTileProps) {
    const { t } = useTranslation();
    const distanceWithUnit = distance ? (<><span className={"sr-only"}>{t("entry_tile.distance")}</span> <span>{`${distance.value} ${distance.unit}`}</span></>) : null;
    const firstLine = [entry.category.name, distanceWithUnit].filter(el => el);

    const address = [entry.position.street, entry.position.housenumber].filter(el => el).join(" ");
    const secondLine = [address, entry.position.city, entry.position.countryCode].filter(el => el);

    return (
        <View padding={4}>
            <View gap={4} direction="row" align="start">
                <Avatar src={entry.mainImageUrl} size={16}/>
                <View.Item grow>
                    <View direction="column" gap={1}>
                        <View direction="row" align={"center"} gap={2} wrap={false} width={"100%"}>
                            <Text variant="body-2" weight="medium" maxLines={1} color={"neutral"} className={"flex-initial!"}>
                                {entry.name}
                            </Text>
                            <QualityBadge quality={entry.quality}/>
                        </View>
                        <Text variant="caption-1" color="neutral-faded" weight="regular" maxLines={1}>
                            {firstLine.map((el, index) => (
                                <Fragment key={index}>
                                    { !!index && <span aria-hidden={true}> • </span> }
                                    { el }
                                </Fragment>
                            ))}
                        </Text>
                        <Text variant="caption-1" color="neutral-faded" weight="regular" maxLines={1}>
                            {secondLine.map((el, index) => (
                                <Fragment key={index}>
                                    { !!index && <span aria-hidden={true}> • </span> }
                                    { el }
                                </Fragment>
                            ))}
                        </Text>
                        <AccessibilityIndicator accessibility={entry.accessibility} pictograms={entry.pictograms} />
                    </View>
                </View.Item>
            </View>
        </View>
    );
}

export function EntryTileLoading() {
    return (
        <View padding={4}>
            <View gap={4} direction="row" align="start">
                <Skeleton height={16} width={16} borderRadius="circular"/>
                <View.Item grow>
                    <View direction="column" gap={1} align="start">
                        <Skeleton width="147px" height={6}/>
                        <Skeleton width="108px" height={4}/>
                        <Skeleton width="219px" height={4}/>
                        <View direction={"row"} gap={1}>
                            <Skeleton width="33px" height={6}/>
                            <Skeleton width="33px" height={6}/>
                            <Skeleton width="33px" height={6}/>
                        </View>
                    </View>
                </View.Item>
            </View>
        </View>
    );
}
